import axios from 'axios'
import {AuthModel, UserModel} from './_models'

const rawApiUrl = process.env.REACT_APP_API_URL || ''
const API_URL = rawApiUrl.replace(/\/+$/, '')

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/users/auth/verify-token`
export const LOGIN_URL = `${API_URL}/users/auth/signin`
export const REGISTER_URL = `${API_URL}/register`
export const REQUEST_PASSWORD_URL = `${API_URL}/forgot_password`

// Server should return AuthModel
export function login(email: string, password: string) {  
  return axios.post<AuthModel>(LOGIN_URL, {
    email,
    password,
  })
}

// Server should return AuthModel
export function register(
  email: string,
  login: string,
  firstname: string,
  lastname: string,
  celphone: string,
  password: string,
  password_confirmation: string
) {
  return axios.post(REGISTER_URL, {
    email,
    login,
    first_name: firstname,
    last_name: lastname,
    celphone,
    password,
    password_confirmation,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{result: boolean}>(REQUEST_PASSWORD_URL, {
    email,
  })
}

export function getUserByToken(token: string) {
  return axios.post<UserModel>(
    GET_USER_BY_ACCESSTOKEN_URL, 
    {
      api_token: token,
    },
    {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    }
  )
}